import { ReactElement } from 'react';
import styles from './plancard.module.scss';
import { ImageWrapper } from '@/shared-components/ImageWrapper/ImageWrapper';

const { mainWrapper, textContentWrapper, headlineStyles, descriptionTextStyles, iconWrapper, icon } = styles;

export interface PlanCardProps {
    headline: string;
    descriptionText: string | ReactElement;
    iconSource: Omit<ImageProps, 'width' | 'height'> & Partial<Pick<ImageProps, 'width' | 'height'>>;
    classNames?: string;
    isHovered?: boolean;
}

const PlanCard = ({ headline, descriptionText, iconSource, classNames = '' }: PlanCardProps): React.JSX.Element => {
    return (
        <div className={`${mainWrapper} ${classNames}`}>
            <div className={textContentWrapper}>
                <span className={headlineStyles}>{headline}</span>
                <span className={descriptionTextStyles}>{descriptionText}</span>
            </div>
            <div aria-hidden="true" className={iconWrapper}>
                <ImageWrapper
                    aria-hidden="true"
                    src={iconSource.source}
                    alt={iconSource.altText ?? ''}
                    optimizedHeight={64}
                    optimizedWidth={64}
                    className={icon}
                />
            </div>
        </div>
    );
};

export default PlanCard;
